import { render, staticRenderFns } from "./VariationEditor.vue?vue&type=template&id=0a75f1c5&"
import script from "./VariationEditor.vue?vue&type=script&lang=js&"
export * from "./VariationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a75f1c5')) {
      api.createRecord('0a75f1c5', component.options)
    } else {
      api.reload('0a75f1c5', component.options)
    }
    module.hot.accept("./VariationEditor.vue?vue&type=template&id=0a75f1c5&", function () {
      api.rerender('0a75f1c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/VariationEditor.vue"
export default component.exports